var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "listContentManage" },
    [
      _c("basic-container", [
        _c(
          "div",
          { staticClass: "query-form-wrap" },
          [
            _c(
              "el-form",
              {
                attrs: {
                  inline: true,
                  model: _vm.searchForm,
                  size: _vm.formSize,
                  "label-width": "88px",
                },
              },
              [
                _c(
                  "el-form-item",
                  [
                    _c("el-input", {
                      attrs: { placeholder: "应用名称" },
                      model: {
                        value: _vm.searchForm.name,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "name", $$v)
                        },
                        expression: "searchForm.name",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  [
                    _c(
                      "el-select",
                      {
                        attrs: {
                          size: "small",
                          filterable: "",
                          clearable: "",
                          placeholder: "应用类型",
                        },
                        model: {
                          value: _vm.searchForm.type,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchForm, "type", $$v)
                          },
                          expression: "searchForm.type",
                        },
                      },
                      _vm._l(_vm.aplicationTypeList, function (item, index) {
                        return _c("el-option", {
                          key: index,
                          attrs: { label: item.bizValue, value: item.bizKey },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  [
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "auth",
                            rawName: "v-auth",
                            value: "PULL_APP_MANAGE_SEARCH",
                            expression: "'PULL_APP_MANAGE_SEARCH'",
                          },
                        ],
                        attrs: { loading: _vm.listLoading, type: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.getListContent(1)
                          },
                        },
                      },
                      [_vm._v("搜索")]
                    ),
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "auth",
                            rawName: "v-auth",
                            value: "PULL_APP_MANAGE_ADD",
                            expression: "'PULL_APP_MANAGE_ADD'",
                          },
                        ],
                        attrs: { plain: "" },
                        on: {
                          click: function ($event) {
                            return _vm.handleClick("", 1)
                          },
                        },
                      },
                      [_vm._v("新增")]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "el-table",
              {
                staticStyle: { width: "100%" },
                attrs: { border: "", data: _vm.tableData, height: "600px" },
              },
              [
                _c("el-table-column", {
                  attrs: { prop: "id", label: "ID", width: "180" },
                }),
                _c("el-table-column", {
                  attrs: { prop: "name", label: "应用名称", width: "180" },
                }),
                _c("el-table-column", {
                  attrs: { prop: "type", label: "应用类型", width: "180" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.getApplicationDes(scope.row.type)) +
                              "\n          "
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: { prop: "icon", label: "应用icon", width: "180" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("el-image", {
                            staticStyle: { width: "50px", height: "50px" },
                            attrs: {
                              src: scope.row.icon,
                              "preview-src-list": [scope.row.icon],
                            },
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return _vm.handleClickItem.apply(
                                  null,
                                  arguments
                                )
                              },
                            },
                          }),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: { prop: "createTime", label: "创建时间" },
                }),
                _c("el-table-column", {
                  attrs: { prop: "remark", label: "备注" },
                }),
                _c("el-table-column", {
                  attrs: { fixed: "right", label: "操作", width: "120" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "auth",
                                  rawName: "v-auth",
                                  value: "PULL_APP_MANAGE_LOG",
                                  expression: "'PULL_APP_MANAGE_LOG'",
                                },
                              ],
                              attrs: { type: "text", size: "small" },
                              on: {
                                click: function ($event) {
                                  return _vm.viewLog(scope.row)
                                },
                              },
                            },
                            [_vm._v("日志")]
                          ),
                          _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "auth",
                                  rawName: "v-auth",
                                  value: "PULL_APP_MANAGE_EDIT",
                                  expression: "'PULL_APP_MANAGE_EDIT'",
                                },
                              ],
                              attrs: { type: "text", size: "small" },
                              on: {
                                click: function ($event) {
                                  return _vm.handleClick(scope.row, 2)
                                },
                              },
                            },
                            [_vm._v("编辑")]
                          ),
                          _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "auth",
                                  rawName: "v-auth",
                                  value: "PULL_APP_MANAGE_DEL",
                                  expression: "'PULL_APP_MANAGE_DEL'",
                                },
                              ],
                              attrs: { type: "text", size: "small" },
                              on: {
                                click: function ($event) {
                                  return _vm.handleClick(scope.row, 3)
                                },
                              },
                            },
                            [_vm._v("删除")]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "block" },
              [
                _c("el-pagination", {
                  attrs: {
                    "current-page": _vm.pagination.current,
                    "page-sizes": [10, 50, 100, 200],
                    "page-size": _vm.pagination.size,
                    layout: "total, sizes, prev, pager, next, jumper",
                    total: _vm.pagination.total,
                  },
                  on: {
                    "size-change": _vm.handleSizeChange,
                    "current-change": _vm.handleCurrentChange,
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.type === 1 ? "新增" : "编辑",
            "append-to-body": "",
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            visible: _vm.visible,
            width: "800px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
            close: _vm.onDialogClose,
          },
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticClass: "dialog-content-wrap",
            },
            [
              _c(
                "el-collapse",
                {
                  attrs: { accordion: "" },
                  model: {
                    value: _vm.activeNames,
                    callback: function ($$v) {
                      _vm.activeNames = $$v
                    },
                    expression: "activeNames",
                  },
                },
                [
                  _c(
                    "el-collapse-item",
                    { attrs: { name: "1" } },
                    [
                      _c("template", { slot: "title" }, [
                        _c("b", [_vm._v("基础配置")]),
                        _c("i", { staticClass: "header-icon el-icon-info" }),
                      ]),
                      _c(
                        "el-form",
                        {
                          ref: "editForm",
                          attrs: {
                            model: _vm.dialogForm,
                            rules: _vm.rules,
                            size: "small",
                            "label-width": "140px",
                          },
                        },
                        _vm._l(_vm.dialogForm, function (item) {
                          return _c(
                            "el-form-item",
                            {
                              key: item.id,
                              ref: item.name,
                              refInFor: true,
                              attrs: { label: item.label, prop: item.name },
                            },
                            [
                              item.type === "input"
                                ? _c("el-input", {
                                    staticStyle: { width: "400px" },
                                    attrs: { placeholder: item.placeholder },
                                    model: {
                                      value: item.value,
                                      callback: function ($$v) {
                                        _vm.$set(item, "value", $$v)
                                      },
                                      expression: "item.value",
                                    },
                                  })
                                : _vm._e(),
                              item.type === "select"
                                ? _c(
                                    "el-select",
                                    {
                                      attrs: { placeholder: item.placeholder },
                                      model: {
                                        value: item.value,
                                        callback: function ($$v) {
                                          _vm.$set(item, "value", $$v)
                                        },
                                        expression: "item.value",
                                      },
                                    },
                                    _vm._l(
                                      _vm.aplicationTypeList,
                                      function (item) {
                                        return _c("el-option", {
                                          key: item.id,
                                          attrs: {
                                            label: item.bizValue,
                                            value: Number(item.bizKey),
                                          },
                                        })
                                      }
                                    ),
                                    1
                                  )
                                : _vm._e(),
                              item.type === "textarea"
                                ? _c("el-input", {
                                    staticStyle: { width: "400px" },
                                    attrs: {
                                      type: "textarea",
                                      rows: 2,
                                      placeholder: item.placeholder,
                                    },
                                    model: {
                                      value: item.value,
                                      callback: function ($$v) {
                                        _vm.$set(item, "value", $$v)
                                      },
                                      expression: "item.value",
                                    },
                                  })
                                : _vm._e(),
                              item.type === "radio"
                                ? _c(
                                    "el-radio-group",
                                    {
                                      model: {
                                        value: item.value,
                                        callback: function ($$v) {
                                          _vm.$set(item, "value", $$v)
                                        },
                                        expression: "item.value",
                                      },
                                    },
                                    [
                                      _c("el-radio", { attrs: { label: 1 } }, [
                                        _vm._v("上架"),
                                      ]),
                                      _c("el-radio", { attrs: { label: 0 } }, [
                                        _vm._v("下架"),
                                      ]),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              item.type === "upload"
                                ? _c(
                                    "el-upload",
                                    {
                                      attrs: {
                                        action: "#",
                                        "list-type": "picture-card",
                                        "on-preview": (file) => {
                                          return _vm.handlePictureCardPreview(
                                            file,
                                            item
                                          )
                                        },
                                        "auto-upload": false,
                                        "file-list": _vm.uploadList(item.name),
                                        "on-change": (file, file_list) => {
                                          return _vm.handleChangeImgs(
                                            file,
                                            file_list,
                                            item.name
                                          )
                                        },
                                        "on-remove": (file, file_list) => {
                                          return _vm.handleRemoveImgs(
                                            file,
                                            file_list,
                                            item
                                          )
                                        },
                                        limit: 1,
                                      },
                                    },
                                    [_c("i", { staticClass: "el-icon-plus" })]
                                  )
                                : _vm._e(),
                              item.type === "upload"
                                ? _c(
                                    "el-dialog",
                                    {
                                      attrs: {
                                        visible: _vm.dialogVisible,
                                        "append-to-body": "",
                                      },
                                      on: {
                                        "update:visible": function ($event) {
                                          _vm.dialogVisible = $event
                                        },
                                      },
                                    },
                                    [
                                      _c("img", {
                                        attrs: {
                                          width: "100%",
                                          src: _vm.dialogImgUrl,
                                        },
                                      }),
                                    ]
                                  )
                                : _vm._e(),
                              item.type === "uploadVedio"
                                ? _c(
                                    "el-upload",
                                    {
                                      attrs: {
                                        action: "#",
                                        "list-type": "picture-card",
                                        "on-preview": (file) => {
                                          return _vm.handlePictureCardPreview(
                                            file,
                                            item
                                          )
                                        },
                                        "auto-upload": false,
                                        "file-list": _vm.uploadList(item.name),
                                        "on-change": (file, file_list) =>
                                          _vm.handleChangeVideo(
                                            file,
                                            file_list,
                                            item.name
                                          ),
                                        "on-remove": (file, file_list) =>
                                          _vm.handleRemoveVideo(
                                            file,
                                            file_list,
                                            item
                                          ),
                                        limit: 1,
                                      },
                                    },
                                    [_c("i", { staticClass: "el-icon-plus" })]
                                  )
                                : _vm._e(),
                              item.type === "uploadVedio"
                                ? _c(
                                    "el-dialog",
                                    {
                                      attrs: {
                                        visible: _vm.dialogVideoVisible,
                                        "append-to-body": "",
                                      },
                                      on: {
                                        "update:visible": function ($event) {
                                          _vm.dialogVideoVisible = $event
                                        },
                                      },
                                    },
                                    [
                                      _c("video", {
                                        attrs: {
                                          width: "100%",
                                          controls: "",
                                          src: _vm.dialogVideoUrl,
                                        },
                                      }),
                                    ]
                                  )
                                : _vm._e(),
                              item.children
                                ? _c("div", { staticStyle: { height: "32px" } })
                                : _vm._e(),
                              _vm._l(item.children, function (subItem) {
                                return _c(
                                  "div",
                                  { key: subItem.id, staticClass: "children" },
                                  [
                                    _c("div", { staticClass: "title" }, [
                                      _vm._v(_vm._s(subItem.label)),
                                    ]),
                                    _c("el-input", {
                                      staticStyle: { width: "400px" },
                                      attrs: {
                                        maxlength: "998",
                                        placeholder: subItem.placeholder,
                                      },
                                      model: {
                                        value: subItem.value,
                                        callback: function ($$v) {
                                          _vm.$set(subItem, "value", $$v)
                                        },
                                        expression: "subItem.value",
                                      },
                                    }),
                                  ],
                                  1
                                )
                              }),
                            ],
                            2
                          )
                        }),
                        1
                      ),
                    ],
                    2
                  ),
                  _c(
                    "el-collapse-item",
                    { attrs: { name: "2" } },
                    [
                      _c("template", { slot: "title" }, [
                        _c("b", [_vm._v("Android手机厂商配置")]),
                        _c("i", { staticClass: "header-icon el-icon-info" }),
                      ]),
                      _c(
                        "el-form",
                        {
                          attrs: {
                            model: _vm.dialogBrandForm,
                            size: "small",
                            "label-width": "140px",
                          },
                        },
                        [
                          _c(
                            "el-form-item",
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "primary", size: "small" },
                                  on: { click: _vm.handleAddBarnd },
                                },
                                [_vm._v("新增厂商")]
                              ),
                            ],
                            1
                          ),
                          _vm._l(
                            _vm.dialogBrandForm.brandList,
                            function (item, index) {
                              return _c(
                                "div",
                                { key: index },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "厂商名称：" } },
                                    [
                                      _c("el-input", {
                                        attrs: {
                                          placeholder: "移动应用厂商名称",
                                        },
                                        model: {
                                          value: item.name,
                                          callback: function ($$v) {
                                            _vm.$set(item, "name", $$v)
                                          },
                                          expression: "item.name",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: "应用市场地址",
                                        placeholder: "应用市场地址",
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        staticStyle: { width: "400px" },
                                        attrs: {
                                          placeholder:
                                            "Android应用市场网站地址",
                                        },
                                        model: {
                                          value:
                                            item.config.officialWebsiteAddress,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              item.config,
                                              "officialWebsiteAddress",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "item.config.officialWebsiteAddress",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm.dialogBrandForm.brandList.length - 1 !==
                                  index
                                    ? _c("el-divider", [_vm._v("分割线")])
                                    : _vm._e(),
                                ],
                                1
                              )
                            }
                          ),
                        ],
                        2
                      ),
                    ],
                    2
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "btn" },
                [
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "auth",
                          rawName: "v-auth",
                          value: "APPS_PCHOTUPGRADE_EDIT",
                          expression: "'APPS_PCHOTUPGRADE_EDIT'",
                        },
                      ],
                      attrs: { size: "mini", type: "primary" },
                      on: { click: _vm.handleEdit },
                    },
                    [_vm._v("保存")]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "auth",
                          rawName: "v-auth",
                          value: "APPS_PCHOTUPGRADE_EDIT",
                          expression: "'APPS_PCHOTUPGRADE_EDIT'",
                        },
                      ],
                      attrs: { size: "mini" },
                      on: { click: _vm.onDialogClose },
                    },
                    [_vm._v("取消")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _c("OptionLog", {
        ref: "optionLog",
        attrs: { columnConfig: _vm.optionLogColumn, closeBtn: false },
        on: { reload: _vm.reloadOpt },
        scopedSlots: _vm._u([
          {
            key: "type",
            fn: function ({ row }) {
              return [
                _c("div", [
                  row.type === 1 ? _c("span", [_vm._v("新增")]) : _vm._e(),
                  row.type === 2 ? _c("span", [_vm._v("修改")]) : _vm._e(),
                  row.type === 3 ? _c("span", [_vm._v("删除")]) : _vm._e(),
                ]),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }